<template>
  <CollapseList
    :title="$t('entity.code', 2)"
    :count="codeCount"
    :collapsed="collapsed"
    data-test-id="collapse-code-pill-list"
    @toggle="$emit('toggle')"
  >
    <template #leftaction>
      <slot name="leftaction" />
    </template>

    <template #rightaction>
      <slot name="rightaction" />
    </template>

    <template #content>
      <CodePillList v-if="codes.length" justify="left" :wrap-column="wrapColumn">
        <template #pill>
          <CodePill
            v-for="code in codes"
            :key="code.id"
            :item="code"
            :attached-at="showCodeUserInfo ? code.attachedAt : null"
            :attached-by="showCodeUserInfo ? code.attachedBy : null"
            :deletable="deletable"
            :editable="editable"
            :count="code.occurrence"
            @delete="$emit('delete', code)"
            @click="$emit('select', code)"
          />
        </template>
      </CodePillList>
      <span v-else class="collapse-code-pill-list__placeholder">{{
        $t(`codePillList.emptyPlaceholder.${entityType}`)
      }}</span>
    </template>
  </CollapseList>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import CodePill from '@components/common/CodePill.vue';
import CodePillList from '@components/common/CodePillList.vue';
import CollapseList from '@components/common/CollapseList.vue';

import { ProjectQuotationCodeAttachmentCode, ProjectQuotationCodeAttachment } from '@/types';

export type FlatCode = ProjectQuotationCodeAttachmentCode &
  Pick<ProjectQuotationCodeAttachment, 'attachedBy' | 'attachedAt'>;

export default defineComponent({
  name: 'CollapseCodePillList',
  emits: { toggle: null, delete: null, select: null },

  components: {
    CodePillList,
    CodePill,
    CollapseList,
  },

  props: {
    codes: {
      type: Array as PropType<Array<FlatCode>>,
      required: true,
    },

    collapsed: {
      type: Boolean,
      default: true,
    },

    deletable: {
      type: Boolean,
      default: false,
    },

    editable: {
      type: Boolean,
      default: false,
    },

    showCodeUserInfo: {
      type: Boolean,
      default: false,
    },

    entityType: {
      type: String,
      required: true,
    },

    wrapColumn: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    codeCount(): number {
      return this.codes.length;
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
.collapse-code-pill-list__placeholder {
  color: colors.$color-grey-500;

  @include typography.typography-15-normal(24px);
}
</style>
